import React, { FC } from 'react'

type IProps = {
    handleClick: () => void;
}

const CloseMenuIconBtn: FC<IProps> = ({ handleClick }) => {
    return (
        <button
            type="button"
            onClick={handleClick}
            className="-m-2.5 rounded-md p-2.5 text-gray-700 closeMobileMenuBtn"
        >
            <span className="sr-only">Close menu</span>
            <svg
                className="size-8"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                data-slot="icon"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                />
            </svg>
        </button>
    )
}

export default CloseMenuIconBtn